var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureTestPlans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47_15504",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 16,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.927 17C32.927 16.4475 33.378 16 33.9345 16H52.066C52.622 16 53.073 16.4475 53.073 17V19C53.073 19.5525 52.622 20 52.066 20H51.0585V29.855L65.681 55C68.0075 59 65.0995 64 60.447 64H25.553C20.9 64 17.9925 59 20.3185 55L34.9415 29.855V20H33.935C33.8032 20.0005 33.6725 19.9751 33.5506 19.9251C33.4286 19.8751 33.3176 19.8016 33.2241 19.7087C33.1305 19.6159 33.0562 19.5055 33.0053 19.3839C32.9544 19.2623 32.928 19.1318 32.9275 19V17H32.927Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47_15504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.766 25C40.092 21 45.908 21 48.234 25L65.681 55C68.0075 59 65.0995 64 60.447 64H25.553C20.9 64 17.9925 59 20.3185 55L37.766 25Z",
    fill: "#854CC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0585 30V20H34.9415V30H51.0585Z",
    fill: "url(#paint0_linear_47_15504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.927 17.0035C32.927 16.45 33.376 16 33.93 16H52.07C52.6245 16 53.0735 16.4495 53.0735 17.0035V18.9965C53.0735 19.2626 52.9678 19.5179 52.7796 19.7061C52.5914 19.8943 52.3361 20 52.07 20H33.93C33.6639 20 33.4086 19.8943 33.2204 19.7061C33.0322 19.5179 32.9265 19.2626 32.9265 18.9965V17.0035H32.927Z",
    fill: "#A676DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0585 20H34.9415V16H51.0585V20Z",
    fill: "#854CC7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7735 50L65.681 55C68.0075 59 65.0995 64 60.447 64H25.553C20.9 64 17.9925 59 20.3185 55L23.2265 50H62.7735Z",
    fill: "#5F1FAA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_47_15504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.761 47.9475C49.192 47.592 51.0585 45.5115 51.0585 43C51.0585 40.2385 48.8035 38 46.022 38C43.4915 38 41.397 39.8515 41.039 42.2655C40.3638 42.0884 39.6685 41.9992 38.9705 42C34.52 42 30.912 45.582 30.912 50C30.912 54.418 34.52 58 38.97 58C43.42 58 47.0285 54.418 47.0285 50C47.0289 49.3071 46.9388 48.6171 46.7605 47.9475H46.761Z",
    fill: "#4D008A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.022 48C48.8035 48 51.0585 45.7615 51.0585 43C51.0585 40.2385 48.8035 38 46.022 38C43.24 38 40.985 40.2385 40.985 43C40.985 45.7615 43.24 48 46.0215 48H46.022Z",
    fill: "#B68CE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.97 58C43.421 58 47.029 54.4185 47.029 50C47.029 45.5815 43.421 42 38.97 42C34.519 42 30.9115 45.5815 30.9115 50C30.9115 54.4185 34.52 58 38.97 58Z",
    fill: "#C9A4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.029 50C47.029 54.4185 43.421 58 38.9705 58C34.52 58 30.912 54.4185 30.912 50H47.029Z",
    fill: "#9B60DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.761 47.947C46.5195 47.982 46.273 48 46.022 48C43.24 48 40.9855 45.761 40.9855 43C40.9855 42.75 41.0035 42.506 41.039 42.266C43.8275 42.999 46.0225 45.1785 46.761 47.9465V47.947Z",
    fill: "#E3CCFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M32.9272 17C32.9272 16.4475 33.3782 16 33.9342 16H52.0662C52.6222 16 53.0732 16.4475 53.0732 17V19C53.0732 19.5525 52.6222 20 52.0662 20H51.0587V29.8565L65.6812 55C68.0077 59 65.0997 64 60.4472 64H25.5532C20.9002 64 17.9927 59 20.3192 55L34.9417 29.8565V20H33.9342C33.8024 20.0005 33.6719 19.975 33.5499 19.925C33.428 19.8749 33.3171 19.8014 33.2236 19.7086C33.1301 19.6157 33.0558 19.5053 33.0049 19.3838C32.9541 19.2622 32.9277 19.1318 32.9272 19V17Z",
    fill: "url(#paint1_linear_47_15504)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_47_15504",
    x: -1.204,
    y: 5.884,
    width: 84.3785,
    height: 84.232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.058,
    result: "effect1_foregroundBlur_47_15504"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_15504",
    x1: 35.9485,
    y1: 24,
    x2: 35.9485,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B3FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6724B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_15504",
    x1: 66.5002,
    y1: 16,
    x2: 66.5002,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureTestPlans);
export default __webpack_public_path__ + "static/media/azure-test-plans.bc4c8b1e79ba50b592c4ed8f9d9950cd.svg";
export { ForwardRef as ReactComponent };